module.exports = __webpack_public_path__ + "static/media/wechat-code.06db38f4.png";